import { CellType } from "../enums";

export class CellTypeHelper {
  static getDescription(value: CellType): string {
    switch (value) {
      case "DEFAULT":
        return "Default";
      case "HIGHLIGHTS":
        return "Highlights";
      case "LANDSCAPE":
        return "Hero Landscape";
      case "COVER":
        return "Cover";
      case "FRAME":
        return "Frame";
      case "PROMO":
        return "Promo";
      case "SQUARE":
        return "Square";
      case "ROUND":
        return "Round";
      case "CHANNEL":
        return "Channel";
      default:
        return "Undefined";
    }
  }

  static getValue(value: string): CellType {
    switch (value) {
      case "DEFAULT":
        return CellType.Default;
      case "HIGHLIGHTS":
        return CellType.Highlights;
      case "LANDSCAPE":
        return CellType.HeroLandscape;
      case "COVER":
        return CellType.Cover;
      case "PROMO":
        return CellType.Promo;
      case "FRAME":
        return CellType.Frame;
      case "SQUARE":
        return CellType.Square;
      case "ROUND":
        return CellType.Round;
      case "CHANNEL":
        return CellType.Channel;
      default:
        return CellType.Default;
    }
  }

  static getStringValue(value: CellType): string {
    switch (value) {
      case CellType.Default:
        return "DEFAULT";
      case CellType.Highlights:
        return "HIGHLIGHTS";
      case "LANDSCAPE":
        return CellType.HeroLandscape;
      case CellType.Cover:
        return "COVER";
      case CellType.Frame:
        return "FRAME";
      case CellType.Promo:
        return "PROMO";
      case CellType.Square:
        return "SQUARE";
      case CellType.Round:
        return "ROUND";
      case CellType.Channel:
        return "CHANNEL";
      default:
        return "DEFAULT";
    }
  }
}
